import Winner_1 from '../images/winners/winner_1.png'
import Winner_2 from '../images/winners/winner_2.png'
import Winner_3 from '../images/winners/winner_3.jpg'
import Winner_4 from '../images/winners/winner_4.jpg'
import Winner_5 from '../images/winners/winner_5.jpg'
import Winner_6 from '../images/winners/winner_6.jpg'
import Winner_7 from '../images/winners/winner_7.jpg'
import Winner_8 from '../images/winners/winner_8.jpg'
import Winner_9 from '../images/winners/winner_9.png'
import Winner_10 from '../images/winners/winner_10.jpg'
import Winner_11 from '../images/winners/winner_11.jpg'
import Winner_12 from '../images/winners/winner_12.jpg'
import Winner_13 from '../images/winners/winner_13.jpg'
import Winner_14 from '../images/winners/winner_14.jpg'
import Winner_15 from '../images/winners/winner_15.jpg'
import Winner_16 from '../images/winners/winner_16.jpg'
import Winner_17 from '../images/winners/winner_17.png'
import Winner_18 from '../images/winners/winner_18.png'
import Winner_19 from '../images/winners/winner_19.jpg'
import Winner_20 from '../images/winners/winner_20.jpg'
import Winner_21 from '../images/winners/winner_21.jpeg'
import Winner_22 from '../images/winners/winner_22.jpg'
import Winner_23 from '../images/winners/winner_23.jpg'
import Winner_24 from '../images/winners/winner_24.jpg'
import Winner_25 from '../images/winners/winner_25.jpg'
import Winner_26 from '../images/winners/winner_26.jpg'
import Winner_27 from '../images/winners/winner_27.jpg'
import Winner_28 from '../images/winners/winner_28.jpg'
import Winner_29 from '../images/winners/winner_29.jpg'
import Winner_30 from '../images/winners/winner_30.jpg'
import Winner_31 from '../images/winners/winner_31.jpeg'
import Winner_32 from '../images/winners/winner_32.jpg'
import Winner_33 from '../images/winners/winner_33.jpg'
import Winner_34 from '../images/winners/winner_34.jpg'
import Winner_35 from '../images/winners/winner_35.png'
import Winner_36 from '../images/winners/winner_36.jpeg'
import Winner_37 from '../images/winners/winner_37.jpg'
import Winner_38 from '../images/winners/winner_38.jpg'
import Winner_39 from '../images/winners/winner_39.jpg'
import Winner_40 from '../images/winners/winner_40.jpg'
import Winner_41 from '../images/winners/winner_41.jpg'
import Winner_42 from '../images/winners/winner_42.jpg'
import Winner_43 from '../images/winners/winner_43.jpg'
import Winner_44 from '../images/winners/winner_44.jpg'
import Winner_45 from '../images/winners/winner_45.png'
import Winner_46 from '../images/winners/winner_46.jpg'
import Winner_47 from '../images/winners/winner_47.jpg'
import Winner_48 from '../images/winners/winner_48.jpg'
import Winner_49 from '../images/winners/winner_49.jpeg'
import Winner_50 from '../images/winners/winner_50.jpg'
import Winner_51 from '../images/winners/winner_51.jpg'
import Winner_52 from '../images/winners/winner_52.jpg'
import Winner_53 from '../images/winners/winner_53.png'
import Winner_54 from '../images/winners/winner_54.jpeg'
import Winner_55 from '../images/winners/winner_55.jpg'
import Winner_56 from '../images/winners/winner_56.png'
import Winner_57 from '../images/winners/winner_57.jpg'
import Winner_58 from '../images/winners/winner_58.png'
import Winner_59 from '../images/winners/winner_59.jpeg'
import Winner_60 from '../images/winners/winner_60.png'
import Winner_61 from '../images/winners/95866.jpg'
import Winner_62 from '../images/winners/winner_62.jpeg'
import Winner_63 from '../images/winners/winner_63.jpg'
import Winner_64 from '../images/winners/winner_64.jpeg'
import Winner_65 from '../images/winners/winner_65.jpg'
import Winner_66 from '../images/winners/winner_66.jpg'
import Winner_67 from '../images/winners/winner_67.jpg'
import Winner_68 from '../images/winners/winner_68.jpg'
import Winner_69 from '../images/winners/winner_69.jpeg'
import Winner_70 from '../images/winners/winner_70.jpg'
import Winner_71 from '../images/winners/winner_71.jpg'
import Winner_72 from '../images/winners/winner_72.jpg'
import Winner_73 from '../images/winners/winner_73.jpg'
import Winner_74 from '../images/winners/winner_74.jpg'
import Winner_75 from '../images/winners/winner_75.jpg'
import Winner_76 from '../images/winners/winner_76.png'
import Winner_77 from '../images/winners/winner_77.jpeg'
import Winner_78 from '../images/winners/winner_78.png'
import Winner_79 from '../images/winners/winner_79.png'
import Winner_80 from '../images/winners/winner_80.jpg'
import Winner_81 from '../images/winners/winner_81.png'
import Winner_82 from '../images/winners/winner_82.png'
import Winner_83 from '../images/winners/winner_83.png'
import Winner_84 from '../images/winners/winner_84.png'
import Winner_85 from '../images/winners/winner_85.png'
import Winner_86 from '../images/winners/winner_86.jpg'
import Winner_87 from '../images/winners/winner_87.png'
import Winner_88 from '../images/winners/winner_88.png'
import { Helmet } from 'react-helmet-async';

const WinnersPage = () => {

  const categories = [
    {
      name: "Международные достижения",
      winners: [
        { year: 2018, name: "Алимбек Турдалиев", country: "Казахстан", image: Winner_1 },
        { year: 2019, name: "Марина Григорян", country: "Армения", image: Winner_2 },
        { year: 2020, name: "Рашид Алиев", country: "Азербайджан", image: Winner_3 },
        { year: 2021, name: "Дмитрий Коваленко", country: "Беларусь", image: Winner_4 },
        { year: 2022, name: "Айгуль Тлеубекова", country: "Киргизия", image: Winner_5 },
        { year: 2023, name: "Леонид Молдован", country: "Молдова", image: Winner_6 },
        { year: 2024, name: "Юлия Петренко", country: "Россия", image: Winner_7 },
        { year: 2025, name: "Ержан Касымбеков", country: "Казахстан", image: Winner_78 },
      ],
    },
    {
      name: "Финансы и инвестиции",
      winners: [
        { year: 2018, name: "Гульнара Садыкова", country: "Таджикистан", image: Winner_8 },
        { year: 2019, name: "Эльнура Омарова", country: "Казахстан", image: Winner_9 },
        { year: 2020, name: "Илья Бондарь", country: "Беларусь", image: Winner_10 },
        { year: 2021, name: "Нигяр Гасымова", country: "Азербайджан", image: Winner_11 },
        { year: 2022, name: "Ольга Демидова", country: "Россия", image: Winner_12 },
        { year: 2023, name: "Тимур Курбанов", country: "Узбекистан", image: Winner_13 },
        { year: 2024, name: "Роман Данилов", country: "Армения", image: Winner_14 },
        { year: 2025, name: "Вардан Саакян", country: "Армения", image: Winner_79 },
      ],
    },
    {
      name: "Строительство и девелопмент",
      winners: [
        { year: 2018, name: "Андрей Зотов", country: "Россия", image: Winner_15 },
        { year: 2019, name: "Алихан Исаев", country: "Туркменистан", image: Winner_16 },
        { year: 2020, name: "Сергей Лисов", country: "Казахстан", image: Winner_17 },
        { year: 2021, name: "Павел Гудков", country: "Беларусь", image: Winner_18 },
        { year: 2022, name: "Карине Мартиросян", country: "Армения", image: Winner_19 },
        { year: 2023, name: "Мурат Рахимов", country: "Киргизия", image: Winner_20 },
        { year: 2024, name: "Светлана Миронова", country: "Молдова", image: Winner_21 },
        { year: 2025, name: "Эмиль Мамедзаде", country: "Азербайджан", image: Winner_80 },
      ],
    },
    {
      name: "Ритейл и торговля",
      winners: [
        { year: 2018, name: "Виктория Беккер", country: "Казахстан", image: Winner_22 },
        { year: 2019, name: "Максим Назаров", country: "Узбекистан", image: Winner_23 },
        { year: 2020, name: "Лейла Халилова", country: "Азербайджан", image: Winner_24 },
        { year: 2021, name: "Алексей Гончарук", country: "Россия", image: Winner_25 },
        { year: 2022, name: "Олег Яценко", country: "Украина", image: Winner_26 },
        { year: 2023, name: "Жанна Алибекова", country: "Киргизия", image: Winner_27 },
        { year: 2024, name: "Игорь Волков", country: "Беларусь", image: Winner_28 },
        { year: 2025, name: "Алексей Гриневич", country: "Беларусь", image: Winner_81 },
      ],
    },
    {
      name: "Туризм и гостеприимство",
      winners: [
        { year: 2018, name: "Елена Ахмедова", country: "Азербайджан", image: Winner_29 },
        { year: 2019, name: "Светлана Астахова", country: "Беларусь", image: Winner_30 },
        { year: 2020, name: "Тимур Нурланов", country: "Казахстан", image: Winner_31 },
        { year: 2021, name: "Гаянэ Саргсян", country: "Армения", image: Winner_32 },
        { year: 2022, name: "Андрей Степанов", country: "Россия", image: Winner_33 },
        { year: 2023, name: "Арсен Юлдашев", country: "Узбекистан", image: Winner_34 },
        { year: 2024, name: "Дарья Кравченко", country: "Украина", image: Winner_35 },
                { year: 2025, name: "Бахтыгуль Садырбекова", country: "Киргизия", image: Winner_82 },
      ],
    },
    {
      name: "Маркетинг и коммуникации",
      winners: [
        { year: 2018, name: "Баходыр Ибрагимов", country: "Узбекистан", image:  Winner_36 },
        { year: 2019, name: "Елена Платонова", country: "Молдова", image:  Winner_37 },
        { year: 2020, name: "Наталья Черноусова", country: "Украина", image:  Winner_38 },
        { year: 2021, name: "Владимир Гудков", country: "Россия", image:  Winner_39 },
        { year: 2022, name: "Диана Тер-Оганян", country: "Армения", image:  Winner_40 },
        { year: 2023, name: "Александр Ильин", country: "Беларусь", image:  Winner_41 },
        { year: 2024, name: "Наргиз Алиева", country: "Азербайджан", image:  Winner_42 },
        { year: 2025, name: "Алина Чобану", country: "Молдова", image: Winner_83 },        
      ],
    },
    {
      name: "Транспорт и логистика",
      winners: [
        { year: 2018, name: "Давид Туманов", country: "Армения", image: Winner_43 },
        { year: 2019, name: "Роман Грищенко", country: "Украина", image: Winner_44 },
        { year: 2020, name: "Нурлан Султанов", country: "Казахстан", image: Winner_45 },
        { year: 2021, name: "Борис Иванов", country: "Россия", image: Winner_46 },
        { year: 2022, name: "Артем Карасев", country: "Молдова", image: Winner_47 },
        { year: 2023, name: "Гулям Назаров", country: "Таджикистан", image: Winner_48 },
        { year: 2024, name: "Жанна Хасанова", country: "Узбекистан", image: Winner_49 },
        { year: 2025, name: "Виктор Орлов", country: "Россия", image: Winner_84 },  
      ],
    },
    {
      name: "Инновации и технологии",
      winners: [
        { year: 2018, name: "Валерий Смирнов", country: "Беларусь", image: Winner_50 },
        { year: 2019, name: "Фархад Гусейнов", country: "Азербайджан", image: Winner_51 },
        { year: 2020, name: "Айгерим Даулетова", country: "Казахстан", image: Winner_52 },
        { year: 2021, name: "Артем Синельников", country: "Россия", image: Winner_53 },
        { year: 2022, name: "Максим Чеботарь", country: "Молдова", image: Winner_54 },
        { year: 2023, name: "Анна Емельяненко", country: "Украина", image: Winner_55 },
        { year: 2024, name: "Марат Исмаилов", country: "Киргизия", image: Winner_56 },
        { year: 2025, name: "Михаил Андрусяк", country: "Россия", image: Winner_85 },  
      ],
    },
    {
      name: "Ресторанный бизнес",
      winners: [
        { year: 2018, name: "Наталья Соколовская", country: "Беларусь", image: Winner_57 },
        { year: 2019, name: "Данияр Асилов", country: "Казахстан", image: Winner_58 },
        { year: 2020, name: "Юлия Бондаренко", country: "Украина", image: Winner_59 },
        { year: 2021, name: "Рустам Каримов", country: "Узбекистан", image: Winner_60 },
        { year: 2022, name: "Сергей Кухилава", country: "Украина", image: Winner_61 },
        { year: 2023, name: "Лариса Хачатурян", country: "Армения", image: Winner_62 },
        { year: 2024, name: "Рахима Насырова", country: "Таджикистан", image: Winner_63 },
        { year: 2025, name: "Тамара Иванеску", country: "Молдова", image: Winner_86 },  
      ],
    },
    {
      name: "Спорт и активный образ жизни",
      winners: [
        { year: 2018, name: "Сергей Матвиенко", country: "Россия", image: Winner_64 },
        { year: 2019, name: "Бахтияр Алиев", country: "Азербайджан", image: Winner_65 },
        { year: 2020, name: "Виктория Белая", country: "Украина", image: Winner_66 },
        { year: 2021, name: "Нурислам Рахимов", country: "Казахстан", image: Winner_67 },
        { year: 2022, name: "Жанна Кириленко", country: "Беларусь", image: Winner_68 },
        { year: 2023, name: "Артем Назарян", country: "Армения", image: Winner_69 },
        { year: 2024, name: "Олеся Мазурова", country: "Молдова", image: Winner_70 },
        { year: 2025, name: "Давид Петросян", country: "Грузия", image: Winner_87 },  
      ],
    },
    {
      name: "Психология и личностное развитие",
      winners: [
        { year: 2018, name: "Оксана Чистякова", country: "Украина", image: Winner_71 },
        { year: 2019, name: "Мария Исмаилова", country: "Киргизия", image: Winner_72 },
        { year: 2020, name: "Антон Широков", country: "Россия", image: Winner_73 },
        { year: 2021, name: "Елена Барсегян", country: "Армения", image: Winner_74 },
        { year: 2022, name: "Юрий Васильев", country: "Беларусь", image: Winner_75 },
        { year: 2023, name: "Саида Шарипова", country: "Узбекистан", image: Winner_76 },
        { year: 2024, name: "Алия Турсунова", country: "Казахстан", image: Winner_77 },
        { year: 2025, name: "Милош Радич", country: "Сербия", image: Winner_88 },  
      ],
    },
    
  ];


  return (
    <>
    <Helmet>
  <title>Победители Международной Премии «Глобальный Прорыв» — Nataliia Chernousova, Sergiy Kukhilava и другие</title>
  <meta
    name="description"
    content="Победители Международной Премии «Глобальный Прорыв». В числе лауреатов: Nataliia Chernousova (Наталья Черноусова) и Sergiy Kukhilava (Сергей Кухилава, Ukraine)."
  />
  <meta
    name="keywords"
    content="победители Глобальный Прорыв, Сергей Кухилава, Sergiy Kukhilava, Kukhilava Sergiy, Наталья Черноусова, Nataliia Chernousova"
  />
  <link rel="canonical" href="https://global-breakthrough.com/winners" />
  <meta name="robots" content="index,follow" />

  <meta property="og:type" content="website" />
  <meta property="og:title" content="Победители премии — Nataliia Chernousova и Sergiy Kukhilava | Глобальный Прорыв" />
  <meta
    property="og:description"
    content="Победители Международной Премии «Глобальный Прорыв». В числе лауреатов: Nataliia Chernousova и Sergiy Kukhilava."
  />
  <meta property="og:url" content="https://global-breakthrough.com/winners" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Победители премии — Глобальный Прорыв",
      "url": "https://global-breakthrough.com/winners",
      "inLanguage": "ru",
      "mainEntity": [
        {
          "@type": "Person",
          "name": "Наталья Черноусова",
          "alternateName": "Nataliia Chernousova",
          "nationality": "Ukraine"
        },
        {
          "@type": "Person",
          "name": "Сергей Кухилава",
          "alternateName": ["Sergiy Kukhilava", "Kukhilava Sergiy"],
          "nationality": "Ukraine",
          "award": "Победитель Международной премии «Глобальный Прорыв» 2022 в номинации «Ресторанный бизнес»"
        }
      ]
    })}
  </script>
</Helmet>
<div className="seo-hidden-name">
  <a href="#nataliia-chernousova">Nataliia Chernousova</a>
  <a href="#sergiy-kukhilava">Sergiy Kukhilava</a>
</div>
    <div
      id="rec273843032"
      className="r t-rec t-rec_pt_0 r_showed r_anim"
      style={{ paddingTop: '0px' }}
      data-record-type="396"
    >

      <div className="t396">


        <div
  className="t396__artboard rendered"
  style={{
    display: "flex",
    alignItems: "center", 
    justifyContent: "center", 
    height: "100vh", 
    position: "relative", 
  }}
>
  <div className="t396__carrier" data-artboard-recid="273843032"></div>
  <div className="t396__filter" data-artboard-recid="273843032"></div>
  <div
    className="t396__elem tn-elem tn-elem__2738430321580382659338"
    data-elem-id="1580382659338"
    data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
    style={{
      position: "absolute",
      width: "920px",
      left: '1023px'
    }}
  >
    <div className="tn-atom">
      <img
        className="tn-atom__img t-img loaded"
        data-original="https://static.tildacdn.com/tild3663-3664-4561-a135-366666386138/ball.png"
        alt=""
        imgfield="tn_img_1580382659338"
        src="https://optim.tildacdn.com/tild3663-3664-4561-a135-366666386138/-/format/webp/ball.png"
      />
    </div>
  </div>
  <div
    className="t396__elem tn-elem tn-elem__2738430321611649501161"
    data-elem-id="1611649501161"
    data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
    style={{ top: '300px', left: '460px', width: '320px' }}
  >
    <div
      className="tn-atom"
      field="tn_text_1611649501161"
      style={{ lineHeight: "18px", textAlign: "start" }}
    >
              ПОБЕДИТЕЛИ 2025-2018
    </div>
  </div>
  <div
    className="t396__elem tn-elem tn-elem__2738430321611649583847"
    data-elem-id="1611649583847"
    data-elem-type="text"
    data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
    style={{
      position: "absolute",
      width: "500px",
      textAlign: "start",
      top: "350px",
      left: '450px'

    }}
  >
    <div
      className="tn-atom"
      field="tn_text_1611649583847"
      style={{ lineHeight: "122px" }}
    >
              ПОБЕДИТЕЛИ
              ПРЕМИИ
    </div>
  </div>
  <div
    className="t396__elem tn-elem tn-elem__2738430321611649933808 t-animate t-animate_started"
    data-elem-id="1611649933808"
    data-field-widthunits-res-960-value="%"
    data-fields="width,height,top,left,container,axisx,axisy,widthunits,heightunits,leftunits,topunits"
    style={{
      position: "absolute",
      width: "1157px",
      height: "2px",
      bottom: "50px",
      transform: "translate3d(0px, -100px, 0px)",
      transitionDuration: "1s",
    }}
  >
    <div className="tn-atom"></div>
  </div>
</div>


      </div>
    </div>
<div id="rec816857420" class="r t-rec t-rec_pt_0 t-rec_pb_75 r_anim r_showed"style={{ paddingTop: '75px', paddingBottom: '75px', backgroundColor: '#1d1c21' }} data-record-type="127">
<div class="t-container flex"> <div class="t-col t-col_11 "> <div class="t119__preface t-descr" field="text">Каждый год Международная Премия «Глобальный Прорыв» собирает бизнес-экспертов и профессионалов, которые обсуждают важнейшие вызовы и тренды, делятся передовым опытом и поддерживают развитие перспективных инициатив. Премия не только отмечает успехи лауреатов, но и предоставляет площадку для обмена идеями и поиска партнерств, создавая ценную сеть контактов среди деловых кругов.<br/>
<br/>Отбор лауреатов осуществляется независимым Экспертным Советом, в который входят высококвалифицированные специалисты различных отраслей. Они тщательно оценивают достижения номинантов, акцентируя внимание на их влиянии на экономику, вклад в общественные инициативы и эффективность их решений. Благодаря строгому отбору награда приобретает особую ценность и подтверждает высокую репутацию своих обладателей.</div> </div> </div>
</div>

<div style={{ paddingTop: '1px', paddingBottom: '75px', backgroundColor: '#1d1c21' }}>
      <div className="t-container">
        {categories.map((category) => (
          <div key={category.name}>
            <h2 className="t-title win-t">{category.name}</h2>
            <div className="winner-cards">
              {category.winners.map((winner) => (
                <div className="card" key={`${winner.year}-${winner.name}`}>
                  <img
                    src={winner.image}
                    alt={`${winner.name}`}
                    className="winner-image"
                  />
                  <div className="card-content">
                  <div className="winner-year">{winner.year}</div>
                    <div className="winner-name">{winner.name}</div>
                    <div className="winner-country">{winner.country}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default WinnersPage;
